/* src/app/components/doc-viewer-new/doc-viewer-context-panel-template/split-sub-panel/split-sub-panel.component.scss */
:host ::ng-deep .mat-tree {
  background-color: #E4E4E4;
  color: #000;
}
:host-context(.dark-theme) .mat-tree {
  background-color: #303030;
  color: #fff;
}
:host ::ng-deep .mat-tree-node {
  min-height: 38px;
  background-color: #E4E4E4;
  color: #000;
}
:host ::ng-deep .mat-tree-node:hover {
  background: rgba(0, 0, 0, 0.32);
}
:host-context(.dark-theme) .mat-tree-node {
  background-color: #303030;
  color: #fff;
}
:host-context(.dark-theme) .mat-tree-node:hover {
  background: rgba(0, 0, 0, 0.32);
}
/*# sourceMappingURL=split-sub-panel.component.css.map */
